define.alias("shared/components/shared/post/secondary/caption-writer/landing-card", "calendar/components/shared/post/secondary/caption-writer/landing-card");